import myHealth from '@web/containers/MyHealth/localization'

import _ from 'lodash'

const localization = {
  en: {
    print: 'Print',
    vaccine: 'Vaccine',
    datesOnFile: 'Date Received'
  },
  es: {
    print: 'Imprimir',
    vaccine: 'Vacuna',
    datesOnFile: 'Fecha En Que Se Recibió'
  },
  keyMapping: {
    print: 'UFD_Print_Button',
    vaccine: 'UFD_Print_Vaccine_Label',
    datesOnFile: 'UFD_Print_Date_Received'
  }
}

export default _.merge(myHealth, localization)
